/* tslint:disable */
/* eslint-disable */
/**
 * SIBR
 * SIBR Backend API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AutocompleteRequest } from '../model';
// @ts-ignore
import { AutocompleteResult } from '../model';
// @ts-ignore
import { AutocompleteStationsResult } from '../model';
// @ts-ignore
import { OutputErrorMessage } from '../model';
// @ts-ignore
import { SearchSuggestionsResult } from '../model';
/**
 * AutocompleteControllerApi - axios parameter creator
 * @export
 */
export const AutocompleteControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Autocomplete from search places and location
         * @param {string} xBffKey bff key header
         * @param {AutocompleteRequest} autocompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSearchPlaces: async (xBffKey: string, autocompleteRequest: AutocompleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('findSearchPlaces', 'xBffKey', xBffKey)
            // verify required parameter 'autocompleteRequest' is not null or undefined
            assertParamExists('findSearchPlaces', 'autocompleteRequest', autocompleteRequest)
            const localVarPath = `/api/v1/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autocompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search suggestions for the given autocomplete type: origin, destination or via
         * @param {string} searchType 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSearchSuggestionsForType: async (searchType: string, xBffKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchType' is not null or undefined
            assertParamExists('findSearchSuggestionsForType', 'searchType', searchType)
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('findSearchSuggestionsForType', 'xBffKey', xBffKey)
            const localVarPath = `/api/v1/search-suggestions-for-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Autocomplete from search stations and location
         * @param {string} xBffKey bff key header
         * @param {AutocompleteRequest} autocompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStations: async (xBffKey: string, autocompleteRequest: AutocompleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('findStations', 'xBffKey', xBffKey)
            // verify required parameter 'autocompleteRequest' is not null or undefined
            assertParamExists('findStations', 'autocompleteRequest', autocompleteRequest)
            const localVarPath = `/api/v1/stations/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autocompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutocompleteControllerApi - functional programming interface
 * @export
 */
export const AutocompleteControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutocompleteControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Autocomplete from search places and location
         * @param {string} xBffKey bff key header
         * @param {AutocompleteRequest} autocompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findSearchPlaces(xBffKey: string, autocompleteRequest: AutocompleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutocompleteResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findSearchPlaces(xBffKey, autocompleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search suggestions for the given autocomplete type: origin, destination or via
         * @param {string} searchType 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findSearchSuggestionsForType(searchType: string, xBffKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchSuggestionsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findSearchSuggestionsForType(searchType, xBffKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Autocomplete from search stations and location
         * @param {string} xBffKey bff key header
         * @param {AutocompleteRequest} autocompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findStations(xBffKey: string, autocompleteRequest: AutocompleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutocompleteStationsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findStations(xBffKey, autocompleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AutocompleteControllerApi - factory interface
 * @export
 */
export const AutocompleteControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutocompleteControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Autocomplete from search places and location
         * @param {string} xBffKey bff key header
         * @param {AutocompleteRequest} autocompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSearchPlaces(xBffKey: string, autocompleteRequest: AutocompleteRequest, options?: any): AxiosPromise<AutocompleteResult> {
            return localVarFp.findSearchPlaces(xBffKey, autocompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search suggestions for the given autocomplete type: origin, destination or via
         * @param {string} searchType 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSearchSuggestionsForType(searchType: string, xBffKey: string, options?: any): AxiosPromise<SearchSuggestionsResult> {
            return localVarFp.findSearchSuggestionsForType(searchType, xBffKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Autocomplete from search stations and location
         * @param {string} xBffKey bff key header
         * @param {AutocompleteRequest} autocompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStations(xBffKey: string, autocompleteRequest: AutocompleteRequest, options?: any): AxiosPromise<AutocompleteStationsResult> {
            return localVarFp.findStations(xBffKey, autocompleteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AutocompleteControllerApi - object-oriented interface
 * @export
 * @class AutocompleteControllerApi
 * @extends {BaseAPI}
 */
export class AutocompleteControllerApi extends BaseAPI {
    /**
     * 
     * @summary Autocomplete from search places and location
     * @param {string} xBffKey bff key header
     * @param {AutocompleteRequest} autocompleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteControllerApi
     */
    public findSearchPlaces(xBffKey: string, autocompleteRequest: AutocompleteRequest, options?: AxiosRequestConfig) {
        return AutocompleteControllerApiFp(this.configuration).findSearchPlaces(xBffKey, autocompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search suggestions for the given autocomplete type: origin, destination or via
     * @param {string} searchType 
     * @param {string} xBffKey bff key header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteControllerApi
     */
    public findSearchSuggestionsForType(searchType: string, xBffKey: string, options?: AxiosRequestConfig) {
        return AutocompleteControllerApiFp(this.configuration).findSearchSuggestionsForType(searchType, xBffKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Autocomplete from search stations and location
     * @param {string} xBffKey bff key header
     * @param {AutocompleteRequest} autocompleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteControllerApi
     */
    public findStations(xBffKey: string, autocompleteRequest: AutocompleteRequest, options?: AxiosRequestConfig) {
        return AutocompleteControllerApiFp(this.configuration).findStations(xBffKey, autocompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
